export default function BrandLogo({ className = 'w-56' }) {
  return <span className={`inline-block max-w-full shrink-0 ${className}`}>
    <span role="img" aria-label="Numerología Cotidiana" className="brand-logo" />
  </span>;
}
